export const quote_slice_name = 'QUOTE';

export const STANDARD_DECISION = 'standard terms';

export const QUOTE_DOCUMENT_FILENAME = '-Quote Document.pdf';

export const quote_thunks = {
  QUOTE_GET_QUOTE_PRICE: `${quote_slice_name}/getQuotePrice`,
  QUOTE_OPEN_QUOTE_DOCUMENT: `${quote_slice_name}/openQuoteDocument`,
};

export const quote_commission_options = {
  INDEMNITY: 'indemnity',
  NONINDEMNITY: 'nonIndemnity',
  HYBRID: 'hybrid',
};
